/*
 * @Author: Michael
 * @Date: 2018-09-18 15:21:00
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-19 10:34:44
 */

export const CHANGE_SUBTRACT_PRIZE_LENGTH: string = 'CHANGE_SUBTRACT_PRIZE_LENGTH';
export const CHANGE_SUBTRACT_LIMITBUYER_NUM: string = 'CHANGE_SUBTRACT_LIMITBUYER_NUM';
export const TOGGLE_PLAY_TYPE: string = 'TOGGLE_PLAY_TYPE';
export const REMOVE_COURSE_DESC: string = 'REMOVE_COURSE_DESC';
export const DOWN_COURSE_DESC: string = 'DOWN_COURSE_DESC';
export const UP_COURSE_DESC: string = 'UP_COURSE_DESC';
export const CHANGE_COURSE_DESC: string = 'CHANGE_COURSE_DESC';
export const CHANGE_OLD_PRIZE_LIST: string = 'CHANGE_OLD_PRIZE_LIST';
export const UPDATE_PRIZE_PICTURE_LIST: string = 'UPDATE_PRIZE_PICTURE_LIST';
export const CHANGE_DISTRIBUTE_PARAMETER: string = 'CHANGE_DISTRIBUTE_PARAMETER';
export const CHANGE_GACHA_PARAMETER: string = 'CHANGE_GACHA_PARAMETER';
export const CHANGE_TOTALTIMES_STATUS: string = 'CHANGE_TOTALTIMES_STATUS';
export const CHANGE_DAYTIMES_STATUS: string = 'CHANGE_DAYTIMES_STATUS';
export const HANDLE_DELETE_PRIZE_IMG: string = 'HANDLE_DELETE_PRIZE_IMG';
export const CHANGE_PRIZE_ITEM: string = 'CHANGE_PRIZE_ITEM';
export const ADD_PRIZE_PICTURE: string = 'ADD_PRIZE_PICTURE';
export const HANDLED_ELETEPRIZE_PROLIST_ITEM: string = 'HANDLED_ELETEPRIZE_PROLIST_ITEM';
export const TOGGLE_GACHA_TYPE: string = 'TOGGLE_GACHA_TYPE';
export const CHANGE_XCXFLAG: string = 'CHANGE_XCXFLAG';
export const CHANGE_ISINVALID: string = 'CHANGE_ISINVALID';
export const CHANGE_ISAGAIN: string = 'CHANGE_ISAGAIN';
export const CHANGE_OPENID: string = 'CHANGE_OPENID';
export const CHANGE_UID: string = 'CHANGE_UID';
export const CHANGE_JOIN_INFO: string = 'CHANGE_JOIN_INFO';
export const CHANGE_SIGNATURE: string = 'CHANGE_SIGNATURE';
export const CHANGE_TITLE: string = 'CHANGE_TITLE';
export const CHANGE_DEADLINE: string = 'CHANGE_DEADLINE';
export const CHANGE_STARTTIME: string = 'CHANGE_STARTTIME';
export const CHANGE_INSTNAME: string = 'CHANGE_INSTNAME';
export const CHANGE_INST_ADDRESS: string = 'CHANGE_INST_ADDRESS';
export const CHANGE_WECHAT_ONLINE_STATUS: string = 'CHANGE_WECHAT_ONLINE_STATUS';
export const CHANGE_XMPAY_STATUS: string = 'CHANGE_XMPAY_STATUS';

export const GET_BGM_LIST: string = 'GET_BGM_LIST';
export const GET_CUSTOMIZE_BGM_LIST: string = 'GET_CUSTOMIZE_BGM_LIST';//自定义音乐列表
export const CHANGE_SELECTED_BGM: string = 'CHANGE_SELECTED_BGM';
export const CHANGE_INST_PHONE: string = 'CHANGE_INST_PHONE';
export const SWITCH_LIMIT_NUMBER: string = 'SWITCH_LIMIT_NUMBER';
export const CHANGE_LIMIT_NUMBER: string = 'CHANGE_LIMIT_NUMBER';
export const SWITCH_CAN_PAY: string = 'SWITCH_CAN_PAY';
export const SWITCH_SMS_VERIFY: string = 'SWITCH_SMS_VERIFY';
export const SWITCH_MUST_MIN_PAY: string = 'SWITCH_MUST_MIN_PAY';
export const CHANGE_PAY_TYPE: string = 'CHANGE_PAY_TYPE';
export const CHANGE_PAY_NUMBER: string = 'CHANGE_PAY_NUMBER'
export const CHANGE_VIRTUAL_GROUP: string = 'CHANGE_VIRTUAL_GROUP';
export const CHANGE_ACTIVITY_RULE: string = 'CHANGE_ACTIVITY_RULE';

export const CHANGE_ACTIVITY_TITLE: string = 'CHANGE_ACTIVITY_TITLE';
export const CHANGE_ACTIVITY_SWITCH: string = 'CHANGE_ACTIVITY_SWITCH';
export const CHANGE_ACTIVITY_INTROS: string = 'CHANGE_ACTIVITY_INTROS';

export const ADD_ACTIVITY_INTROS: string = 'ADD_ACTIVITY_INTROS';
export const REMOVE_ACTIVITY_INTROS: string = 'REMOVE_ACTIVITY_INTROS';
export const UP_ACTIVITY_INTROS: string = 'UP_ACTIVITY_INTROS';
export const DOWN_ACTIVITY_INTROS: string = 'DOWN_ACTIVITY_INTROS';
export const REPLACE_ACTIVITY_INTROS: string = 'REPLACE_ACTIVITY_INTROS';

export const CHANGE_CONTACT_INFO: string = 'CHANGE_CONTACT_INFO';
export const CHANGE_CONTACT_TITLE: string = 'CHANGE_CONTACT_TITLE';
export const CHANGE_CONTACT_SWITCH: string = 'CHANGE_CONTACT_SWITCH';

export const CHANGE_INSTITUTION_TITLE: string = 'CHANGE_INSTITUTION_TITLE';
export const CHANGE_INSTITUTION_SWITCH: string = 'CHANGE_INSTITUTION_SWITCH';
export const CHANGE_INSTITUTION_INTROS: string = 'CHANGE_INSTITUTION_INTROS';
export const ADD_INSTITUTION_INTROS: string = 'ADD_INSTITUTION_INTROS';

export const ADD_COURSE_DESC: string = 'ADD_COURSE_DESC';
export const REMOVE_INSTITUTION_INTROS: string = 'REMOVE_INSTITUTION_INTROS';
export const UP_INSTITUTION_INTROS: string = 'UP_INSTITUTION_INTROS';
export const DOWN_INSTITUTION_INTROS: string = 'DOWN_INSTITUTION_INTROS';
export const UPDATE_CONFIG_STATE: string = 'UPDATE_CONFIG_STATE';
export const UPDATE_DETAIL_DATA: string = 'UPDATE_DETAIL_DATA';
export const UPDATE_GACHATYPE_PARAMETER: string = 'UPDATE_GACHATYPE_PARAMETER';
export const CHANGE_COVER_TINY: string = 'CHANGE_COVER_TINY';
export const CHANGE_LIMIT_FLAG: string = 'CHANGE_LIMIT_FLAG';
export const CHANGE_LIMIT_FLAG_NUMBER: string = 'CHANGE_LIMIT_FLAG_NUMBER';
export const CHANGE_JOIN_NUMBER: string = 'CHANGE_JOIN_NUMBER';
export const CHANGE_SCAN_NUMBER: string = 'CHANGE_SCAN_NUMBER';
export const CHANGE_EXT_ID: string = 'CHANGE_EXT_ID';
export const CHANGE_BARGAIN_PARAMETER: string = 'CHANGE_BARGAIN_PARAMETER';
export const CHANGE_TYTYPE_PARAMETER: string = 'CHANGE_TYTYPE_PARAMETER';

export const CHANGE_RELEASE_STATUS: string = 'CHANGE_RELEASE_STATUS';

// 修改支付通道
export const CHANGE_SUPPORT_PAY: string = 'CHANGE_SUPPORT_PAY';
export const CHANGE_XM_PAY: string = 'CHANGE_XM_PAY';


export const CHANGE_SECTION_INFO: string = 'CHANGE_SECTION_INFO';
// 砍价、集赞-课程描述 prizeIntros
export const CHANGE_PRIZE_INTROS: string = 'CHANGE_PRIZE_INTROS';
export const ADD_PRIZE_INTROS: string = 'ADD_PRIZE_INTROS';
export const REMOVE_PRIZE_INTROS: string = 'REMOVE_PRIZE_INTROS';
export const UP_PRIZE_INTROS: string = 'UP_PRIZE_INTROS';
export const DOWN_PRIZE_INTROS: string = 'DOWN_PRIZE_INTROS';
// 团购、群接龙-课程描述 courseIntros
export const CHANGE_COURSE_INTROS: string = 'CHANGE_COURSE_INTROS';
export const ADD_COURSE_INTROS: string = 'ADD_COURSE_INTROS';
export const REMOVE_COURSE_INTROS: string = 'REMOVE_COURSE_INTROS';
export const UP_COURSE_INTROS: string = 'UP_COURSE_INTROS';
export const DOWN_COURSE_INTROS: string = 'DOWN_COURSE_INTROS';

// 团购-多课程
export const CHANGE_COURSE_TYPE: string = 'CHANGE_COURSE_TYPE'; // 单/多课程类型
export const ADD_COURSE_GROUP_INTROS: string = 'ADD_COURSE_GROUP_INTROS';
export const DOWN_COURSE_GROUP_INTROS: string = 'DOWN_COURSE_GROUP_INTROS';
export const UP_COURSE_GROUP_INTROS: string = 'UP_COURSE_GROUP_INTROS';
export const REMOVE_COURSE_GROUP_INTROS: string = 'REMOVE_COURSE_GROUP_INTROS';
export const CHANGE_COURSE_GROUP_INTROS: string = 'CHANGE_COURSE_GROUP_INTROS';
export const CHANGE_COURSE_GROUP_LADDER: string = 'CHANGE_COURSE_GROUP_LADDER';
export const CHANGE_COURSE_GROUP_ORIGINPRICE: string = 'CHANGE_COURSE_GROUP_ORIGINPRICE';
export const CHANGE_SELECTED_SEQNO: string = 'CHANGE_SELECTED_SEQNO';

export const CHANGE_CHOOSE_DEGREE: string = 'CHANGE_CHOOSE_DEGREE';
export const CHANGE_RANK_LIST: string = 'CHANGE_RANK_LIST';
export const CHANGE_URL_UID: string = 'CHANGE_URL_UID';
export const CHANGE_CHANCE_COUNT: string = 'CHANGE_CHANCE_COUNT';
export const CHANGE_GROUP_SWITCH: string = 'CHANGE_GROUP_SWITCH';
export const CHANGE_UNGROUP_SWITCH: string = 'CHANGE_UNGROUP_SWITCH';// 未成团列表开关
export const CHANGE_AUTO_CANCEL: string = 'CHANGE_AUTO_CANCEL'; // 拼团失败自动取消报名
export const CHANGE_GROUP_IMAGE_LIST: string = 'CHANGE_GROUP_IMAGE_LIST';
export const CHANGE_GROUP_LIST: string = 'CHANGE_GROUP_LIST';
export const CHANGE_GROUP_NUMBER: string = 'CHANGE_GROUP_NUMBER';
export const CHANGE_GROUP_FULL: string = 'CHANGE_GROUP_FULL';
export const CHANGE_SHOW_FOOTER: string = 'CHANGE_SHOW_FOOTER';
export const CHANGE_HAS_PAY: string = 'CHANGE_HAS_PAY';
export const CHANGE_CANNEL: string = 'CHANGE_CANNEL';
export const HAS_SIGN_IN: string = 'HAS_SIGN_IN';
export const CHANGE_SHOW_JOIN_FOOTER: string = 'CHANGE_SHOW_JOIN_FOOTER';
export const CHANGE_JOIN_GROUP_FLAG: string = 'CHANGE_JOIN_GROUP_FLAG';
export const CHANGE_ORIGINAL_TITLE: string = 'CHANGE_ORIGINAL_TITLE';
export const CHANGE_DOCUMENT_TITLE: string = 'CHANGE_DOCUMENT_TITLE';
export const CHANGE_VIEW_BACKGROUND: string = 'CHANGE_VIEW_BACKGROUND';  // 修改活动主题
export const CHANGE_CONTACT_QRCODE: string = 'CHANGE_CONTACT_QRCODE';
export const CHANGE_SIGNUP_ITEM_CONFIG: string = 'CHANGE_SIGNUP_ITEM_CONFIG'; // 修改报名信息设置
export const CHANGE_USERAWARD_InfO: string = 'CHANGE_USERAWARD_InfO'; // 修改报名信息设置
export const CHANGE_SHOW_BARRAGE: string = 'CHANGE_SHOW_BARRAGE'; // 是否开启弹幕
export const CHANGE_SHOW_NUM: string = 'CHANGE_SHOW_NUM'; // 是否开启相应数据展示
export const CHANGE_SHOW_DATA: string = 'CHANGE_SHOW_DATA'; // 是否开启统计数据展示
export const CHANGE_BUY_XMMAJORDOMO: string = 'CHANGE_BUY_XMMAJORDOMO'; // 是否购买小麦管家
export const CHANGE_POSTER_NAME: string = 'CHANGE_POSTER_NAME';  // 这三个是跟海报相关的
export const CHANGE_POSTER_AVATAR: string = 'CHANGE_POSTER_AVATAR';
export const CHANGE_POSTER_URL: string = 'CHANGE_POSTER_URL';
export const CHANGE_SHOW_IWANT_DO: string = 'CHANGE_SHOW_IWANT_DO'; //  是否显示我也要招生
export const CHANGE_LADDER_GROUP: string = 'CHANGE_LADDER_GROUP';
export const CHANGE_HEAD_REWARD: string = 'CHANGE_HEAD_REWARD';
export const CHANGE_LEFTQUOTA: string = 'CHANGE_LEFTQUOTA';
export const CHANGE_SOLITAIREING_LIST: string = 'CHANGE_SOLITAIREING_LIST';
export const CHANGE_HASPAID_NUMBER: string = 'CHANGE_HASPAID_NUMBER';
export const CHANGE_MATERIAL_STATUA: string = 'CHANGE_MATERIAL_STATUA';
export const CHANGE_INSTSMS_VERIFY: string = 'CHANGE_INSTSMS_VERIFY';
export const CHANGE_SMS_REMAIN_NUMBER: string = 'CHANGE_SMS_REMAIN_NUMBER';
export const CHANGE_PAY_EDIT_MODAL: string = 'CHANGE_PAY_EDIT_MODAL';
export const CHANGE_INVALID_MODAL: string = 'CHANGE_INVALID_MODAL';
export const SWITCH_PONTENTIAL_JOIN: string = 'SWITCH_PONTENTIAL_JOIN';
export const CHANGE_SELECTED_CARD_INDEX: string = 'CHANGE_SELECTED_CARD_INDEX';
export const CHANGE_GACHA_LOADING: string = 'CHANGE_GACHA_LOADING';
export const CHANGE_GACHA_START: string = 'CHANGE_GACHA_START';
export const CHANGE_DETAIL_LOADED: string = 'CHANGE_DETAIL_LOADED';
export const CHANGE_SHOW_WESITEBTN: string = 'CHANGE_SHOW_WESITEBTN';
export const CHANGE_AVATAR: string = 'CHANGE_AVATAR';
export const CHANGE_NICKNAME: string = 'CHANGE_NICKNAME';
export const CHANGE_DISTRIBUTE_ORDER_CREATETIME: string = 'CHANGE_DISTRIBUTE_ORDER_CREATETIME';
export const CHANGE_MY_REWARD: string = 'CHANGE_MY_REWARD';
export const CHANGE_DISTRIBUTE_PURCHASE_LIST: string = 'CHANGE_DISTRIBUTE_PURCHASE_LIST';
export const CHANGE_DISTRIBUTE_TRADE_ID: string = 'CHANGE_DISTRIBUTE_TRADE_ID';
export const CHANGE_DISTRIBUTE_TAB_FIXED: string = 'CHANGE_DISTRIBUTE_TAB_FIXED';
export const CHANGE_INST_IDS: string = 'CHANGE_INST_IDS';
export const CHANGE_INST_LIST: string = 'CHANGE_INST_LIST';
export const CHANGE_INST_NAME_NOT: string = 'CHANGE_INST_NAME_NOT';
export const CHANGE_INST_NAME_FEW: string = 'CHANGE_INST_NAME_FEW';
export const CHANGE_INST_NAME_ZERO: string = 'CHANGE_INST_NAME_ZERO';
export const CHANGE_LEADERS_INST_ID: string = 'CHANGE_LEADERS_INST_ID';
export const CHANGE_PAY_INST_ID: string = 'CHANGE_PAY_INST_ID';


